import React, { useEffect, useState } from "react";
import { Box, Button, Stack, TextField } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  ApproveButton,
  CancelButton,
  RejectButton,
  SubmitButton,
  UpdateButton,
} from "../../../../../components/mui/Buttons/Buttons";
import Loader from "../../../../../components/Loader/Loader";
import { SlideLoader } from "../../../../../components/Loader/SlideLoader";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useSnackbar } from "notistack";
import { getEvaluationTracker, postEvaluation } from "../../../../../redux/features/CRDslice";
import { useDispatch } from "react-redux";
const AddOrEditCheckList = ({
  checkedTrue,
  link,
  id,
  otherLinkTrue,
  labelName,
  admissionNo,
  isDisable
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const dispatch=useDispatch()
  const loading = false;
  const initialValues = {
    link: link ? link : "",
    checked: checkedTrue,
  };

  const schema = Yup.object({
    checked: Yup.boolean(),
    link: Yup.string()
      .trim()
      .nullable()
      .when("checked", {
        is: true,
        then: (schema) =>
          schema
            .required("Link is required when checked")
            .min(1, "Link cannot be empty"),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(values);
      const data = {
        evaluation_tracker_id: id,
        evaluation_tracker_admn_no: admissionNo,
        checklist:otherLinkTrue?false: values.checked,
        link: values.link,
      };
      dispatch(postEvaluation(data)).then((res) => {
        if (res.payload.status === "error") {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
        } else if (res.payload.status === "success") {
          handleCancel();
          dispatch(getEvaluationTracker(admissionNo));
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
        }
      });
    },
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const handleCheckChange = () => {
    formik.setFieldValue("checked", !formik.values.checked);
  };

  useEffect(() => {
    if (!formik.values.checked) {
      formik.setFieldValue("link", "");
    } else {
      formik.setFieldValue("link", link);
    }
  }, [formik.values.checked]);
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          {checkedTrue ? (
            <ApproveButton action={() => setOpen(true)}>
              {otherLinkTrue ? "Other Link Added" : "Completed"}
            </ApproveButton>
          ) : (
            <RejectButton action={() => setOpen(true)} disabled={isDisable}>
              {otherLinkTrue ? "No Links Yet" : "Not Completed"}
            </RejectButton>
          )}
        </>
      }
      content={
        open ? (
          loading ? (
            <SlideLoader />
          ) : (
            <>
              <Box mb={1}>
                <FormControlLabel
                  //   disabled={id ? false : true}
                  label={labelName}
                  control={
                    <Checkbox
                      checked={formik.values.checked}
                      onChange={handleCheckChange}
                    />
                  }
                />
              </Box>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Stack gap={2}>
                      <Box>
                        <TextField
                          disabled={!formik.values.checked}
                          type="text"
                          autoComplete="off"
                          fullWidth
                          id="link"
                          label="Link"
                          name="link"
                          value={formik.values.link}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.link && Boolean(formik.errors.link)
                          }
                          helperText={formik.touched.link && formik.errors.link}
                        />
                      </Box>
                    </Stack>
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                  >
                    <Stack direction={"row"} spacing={1}>
                      <CancelButton action={() => handleCancel()}>
                        Cancel
                      </CancelButton>
                      {id ? (
                        <UpdateButton   type="submit" disabled={loading || (!formik.values.checked)}>
                          {loading ? "Updating..." : "Update"}
                        </UpdateButton>
                      ) : (
                        <SubmitButton
                          disabled={loading || (!formik.values.checked)}
                          type="submit"
                        >
                          {loading ? "Submiting..." : "Submit"}
                        </SubmitButton>
                      )}
                    </Stack>
                  </Box>
                </Form>
              </FormikProvider>
            </>
          )
        ) : null
      }
    />
  );
};

export default AddOrEditCheckList;
